import React, { useState } from "react";
import SocialLogInPanel from "container/account/socialLogin/SocialLogInPanel";
import FullScreenLoadingView from "presentational/common/FullScreenLoadingView";
import config from "lib/fr-config";
import Service from "lib/service-amp";
import { getQueryObjFromUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";
import { withStore } from "store/storeHandler";

const REFERRAL_QUERY_INDEX = config.referralUrlQueryIndex;

RootSocialLogIn.propTypes = {
  goToEmailPage: PropTypes.func.isRequired
};

function RootSocialLogIn(props) {
  const { goToEmailPage, AppErrorActions } = props;
  const [isLoading, setIsLoading] = useState(false);

  const resetReferralData = () => {
    const { refOutfit, refUsername } = REFERRAL_QUERY_INDEX;
    sessionStorage.removeItem(refOutfit);
    sessionStorage.removeItem(refUsername);
  };

  const getReferralDataFromURL = () => {
    const nowUrlQryStr = window.location.search;
    const queryObj = getQueryObjFromUrl(nowUrlQryStr);
    const { refOutfit, refUsername } = REFERRAL_QUERY_INDEX;
    if (!!queryObj[refOutfit]) {
      return { [refOutfit]: queryObj[refOutfit] };
    } else if (!!queryObj[refUsername]) {
      return { [refUsername]: queryObj[refUsername] };
    } else {
      return {};
    }
  };

  const saveReferralDataToSessionStorage = dataObj => {
    Object.entries(dataObj).forEach(([key, value]) => {
      sessionStorage.setItem(key, value);
    });
  };

  const handleEmailBtnClick = () => {
    goToEmailPage();
  };

  const handleGoogleBtnClick = async () => {
    const { isReady } = Service.isGoogleLoginReady().res;
    if (!isReady) {
      return null;
    }

    setIsLoading(true);

    resetReferralData();
    const dataObj = getReferralDataFromURL();
    saveReferralDataToSessionStorage(dataObj);

    const result = await Service.logInWithGoogle();
    if (result.code !== "ok") {
      AppErrorActions.setFatalAppError(result.res);
    }
  };

  return (
    <div>
      <SocialLogInPanel
        onEmailBtnClick={handleEmailBtnClick}
        onGoogleBtnClick={handleGoogleBtnClick}
      />
      {isLoading && <FullScreenLoadingView />}
    </div>
  );
}

export default withStore({
  dispatchMap: ["appError"]
})(RootSocialLogIn);
